export default __webpack_public_path__ + "static/media/tab_logo_green.f4fb4eaf.png";